import { render, staticRenderFns } from "./compAuthentication.vue?vue&type=template&id=86ec62de&scoped=true&"
import script from "./compAuthentication.vue?vue&type=script&lang=js&"
export * from "./compAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./compAuthentication.vue?vue&type=style&index=0&id=86ec62de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ec62de",
  null
  
)

export default component.exports